import React from "react";
import { graphRoot } from "./type_router";
import { Routes, Route } from "react-router-dom";
import { PageGraphInternal, PageGraphArea, PageGraphSemaforo } from '../pages/inmersys'

export const GraphRouter = () => {
    return (
        <Routes>
            <Route path={graphRoot.internal} element={<PageGraphInternal />} />
            <Route path={graphRoot.area} element={<PageGraphArea />} />
            <Route path={graphRoot.semaforo} element={<PageGraphSemaforo />} />
        </Routes>
    );
};
